/**
 * @description Foundation Channel Partner admin. nav (LYN-309)
 *
 * @notes Locked order. No Audit Logs / Application / Transactions / Websites.
 */

export const CHANNEL_PARTNER_NAV = [
  { to: '/cp/dashboard', label: 'Dashboard' },
  { to: '/cp/sales-orgs', label: 'Sales Orgs' },
  { to: '/cp/merchants', label: 'Merchants' },
  { to: '/cp/my-company', label: 'My Company' },
  { to: '/cp/integrations', label: 'Integrations' },
  { to: '/cp/settings', label: 'Settings' },
];
